import React from "react";
import style from "./FactorDescription.module.css";
import Bg from "/assets/PdfNew/pgbg5.png";

const FactorDescription = () => {
  return (
    <div className={style.wrapper}>
      <img src={Bg} alt="background" className={style.wrapper} />

      <div className={style.content}>
        <h2 className={style.title}>6 Factors. One Clear Career Path</h2>

        <p className={style.intro}>
          At Swayamrise, we combine advanced AI with expert-designed tools to
          guide your career journey. Each factor is carefully selected to
          reflect who you are and where you can thrive.
        </p>

        <ol className={style.list}>
          <li>
            <strong>Class Results:</strong> Reveal academic strengths and
            learning patterns. Analysed to understand your performance trends
            and subject mastery.
          </li>

          <li>
            <strong>Subject Interest:</strong> Highlights natural curiosity and
            engagement. Helps match you with fields that genuinely excite and
            motivate you.
          </li>

          <li>
            <strong>Notes from Teachers and Parents:</strong> Add real-world
            observations and behavioural insights. Capture how others see your
            strengths, habits, and growth areas.
          </li>

          <li>
            <strong>Hobbies and Generic Questions:</strong> Connect personal
            interests to career possibilities, showing how your everyday
            choices reflect deeper preferences and skills.
          </li>

          <li>
            <strong>Aptitude Test:</strong> Measures core abilities like logic,
            language, and spatial thinking. Expert-designed tests reveal your
            natural talents and growth potential.
          </li>

          <li>
            <strong>Personality Tests:</strong> Define your working style,
            decision-making, and team fit. AI interprets your traits to suggest
            careers that align with who you are.
          </li>
        </ol>
      </div>
    </div>
  );
};

export default FactorDescription;